module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tab', {
    attrs: {
      "items": _vm.items
    }
  }, [_c('div', {
    attrs: {
      "slot": "common"
    },
    slot: "common"
  }, [_c('div', {
    staticClass: "layui-form-item"
  }, [_c('label', {
    staticClass: "layui-form-label"
  }, [_vm._v("输入框")]), _vm._v(" "), _c('div', {
    staticClass: "layui-input-block"
  }, [_c('input', {
    staticClass: "layui-input",
    attrs: {
      "type": "text",
      "name": "title",
      "required": "",
      "lay-verify": "required",
      "placeholder": "请输入标题",
      "autocomplete": "off"
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "menus"
    },
    slot: "menus"
  }, [_c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.menuOptions,
      "hasNull": true
    },
    on: {
      "change": _vm.changeSelect
    },
    model: {
      value: (_vm.selectValue),
      callback: function($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectMenu.menuName),
      expression: "selectMenu.menuName"
    }],
    staticClass: "layui-input",
    attrs: {
      "type": "text",
      "placeholder": "菜单名称"
    },
    domProps: {
      "value": (_vm.selectMenu.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectMenu, "menuName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectMenu.menuUrl),
      expression: "selectMenu.menuUrl"
    }],
    staticClass: "layui-input",
    attrs: {
      "type": "text",
      "placeholder": "菜单链接"
    },
    domProps: {
      "value": (_vm.selectMenu.menuUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectMenu, "menuUrl", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectMenu.sort),
      expression: "selectMenu.sort"
    }],
    staticClass: "layui-input",
    attrs: {
      "type": "number",
      "placeholder": "菜单排序"
    },
    domProps: {
      "value": (_vm.selectMenu.sort)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectMenu, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_vm._v("\n      显示状态\n      "), _c('v-checkbox', {
    attrs: {
      "text": "首页隐藏"
    },
    model: {
      value: (_vm.selectMenu.indexHide),
      callback: function($$v) {
        _vm.$set(_vm.selectMenu, "indexHide", $$v)
      },
      expression: "selectMenu.indexHide"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "text": "导航隐藏"
    },
    model: {
      value: (_vm.selectMenu.navHide),
      callback: function($$v) {
        _vm.$set(_vm.selectMenu, "navHide", $$v)
      },
      expression: "selectMenu.navHide"
    }
  })], 1), _vm._v(" "), (_vm.selectValue) ? _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('v-button', {
    on: {
      "click": _vm.saveSetting
    }
  }, [_vm._v("保存菜单")]), _vm._v(" "), (_vm.selectMenu.custom) ? _c('v-button', {
    on: {
      "click": _vm.removeCustomMenu
    }
  }, [_vm._v("删除")]) : _vm._e()], 1) : _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('v-button', {
    on: {
      "click": _vm.addCustomMenu
    }
  }, [_vm._v("添加菜单")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "fanyi"
    },
    slot: "fanyi"
  }, [_c('fieldset', {
    staticClass: "layui-elem-field"
  }, [_c('legend', [_vm._v("百度")]), _vm._v(" "), _c('div', {
    staticClass: "layui-field-box"
  }, [_c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fanyiConfig.baiduAppId),
      expression: "fanyiConfig.baiduAppId"
    }],
    staticClass: "layui-input",
    attrs: {
      "type": "text",
      "placeholder": "百度APPID"
    },
    domProps: {
      "value": (_vm.fanyiConfig.baiduAppId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fanyiConfig, "baiduAppId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fanyiConfig.baiduAppKey),
      expression: "fanyiConfig.baiduAppKey"
    }],
    staticClass: "layui-input",
    attrs: {
      "type": "text",
      "placeholder": "百度密钥"
    },
    domProps: {
      "value": (_vm.fanyiConfig.baiduAppKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fanyiConfig, "baiduAppKey", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('fieldset', {
    staticClass: "layui-elem-field"
  }, [_c('legend', [_vm._v("有道")]), _vm._v(" "), _c('div', {
    staticClass: "layui-field-box"
  }, [_c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fanyiConfig.youdaoAppId),
      expression: "fanyiConfig.youdaoAppId"
    }],
    staticClass: "layui-input",
    attrs: {
      "type": "text",
      "placeholder": "有道应用ID"
    },
    domProps: {
      "value": (_vm.fanyiConfig.youdaoAppId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fanyiConfig, "youdaoAppId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fanyiConfig.youdaoAppKey),
      expression: "fanyiConfig.youdaoAppKey"
    }],
    staticClass: "layui-input",
    attrs: {
      "type": "text",
      "placeholder": "有道密钥"
    },
    domProps: {
      "value": (_vm.fanyiConfig.youdaoAppKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fanyiConfig, "youdaoAppKey", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('v-button', {
    on: {
      "click": _vm.saveFanyiConfig
    }
  }, [_vm._v("保存配置")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32979af2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/setting.vue
// module id = 586
// module chunks = 2